<template>
  <div class="order-info-container">
    <div class="main">
      <div class="table-warp">
        <UDLayout>
          <div slot="top" class="table-title">
            关联表单
          </div>
          <el-table
            slot="bottom"
            :data="tableData"
            style="width: 100%"
            header-row-class-name="order-table-header"
            row-class-name="order-table-row"
          >
            <el-table-column prop="func_form_name" label="表单名称" width="180">
            <template #default="{ row }">
              <p style="display: flex; align-items: center">
                <svg t="1653890844317" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="30026" width="14" height="14"><path d="M215.552 64.128L795.904 64c57.088 0 77.76 5.952 98.56 17.088 20.928 11.136 37.312 27.52 48.448 48.384 11.136 20.864 17.088 41.6 17.088 98.56v567.872c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-10.24-19.264-16.128-38.4-16.96-86.08L64 228.096c0-57.088 5.952-77.76 17.088-98.56 11.136-20.928 27.52-37.312 48.384-48.448 19.264-10.24 38.4-16.128 86.08-16.96z" fill="#56CE75" p-id="30027"></path><path d="M64 731.904c0 57.088 5.952 77.76 17.088 98.56 11.136 20.928 27.52 37.312 48.384 48.448 19.264 10.24 38.4 16.128 86.08 16.96l12.544 0.128h567.808c57.088 0 77.76-5.952 98.56-17.088 20.928-11.136 37.312-27.52 48.448-48.384 10.24-19.264 16.128-38.4 16.96-86.08l0.128 51.456c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-11.136-20.864-17.088-41.6-17.088-98.56v-64z" fill="#000000" fill-opacity=".1" p-id="30028"></path><path d="M464 224a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16H375.936l0.064 160a16 16 0 0 1-16 16h-48a16 16 0 0 1-16-16l-0.064-160H208A16 16 0 0 1 192 288v-48a16 16 0 0 1 16-16h256z" fill="#FFFFFF" p-id="30029"></path><path d="M816 400a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16h-224A16 16 0 0 1 576 464V416a16 16 0 0 1 16-16h224z m0-176a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16h-224A16 16 0 0 1 576 288v-48a16 16 0 0 1 16-16h224z" fill="#FFFFFF" fill-opacity=".7" p-id="30030"></path><path d="M816 736a16 16 0 0 1 16 16v48a16 16 0 0 1-16 16h-608A16 16 0 0 1 192 800v-48a16 16 0 0 1 16-16h608z m0-160a16 16 0 0 1 16 16V640a16 16 0 0 1-16 16h-608A16 16 0 0 1 192 640v-48A16 16 0 0 1 208 576h608z" fill="#FFFFFF" fill-opacity=".4" p-id="30031"></path></svg>
                <span style="margin-left: 10px">{{ row.func_form_name }}</span>
              </p>
            </template>
            </el-table-column>
            <el-table-column prop="func_form" label="表单编号" width="230"></el-table-column>
            <el-table-column label="责任人">
              <template #default="{ row }">
                {{ getUsers(row.target_users) }}
              </template>
            </el-table-column>
            <el-table-column prop="sign" label="执行方式">
              <template #default="{ row }">
                <span v-if="row.run_flow === 1">发起后流转</span>
                <span v-if="row.run_flow === 2">流程结束后</span>
                <span v-if="row.run_flow === 3">责任人决策</span>
                <span v-if="row.run_flow === 4">自定义条件</span>
              </template>
            </el-table-column>
            <el-table-column label="当前状态">
              <template #default="{ row }">
                <span v-if="row.status === 0" class="status status-1">
                  待处理
                </span>
                <span v-if="row.status === 1" class="status status-2">
                  已处理
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作">
              <template #default="{ row }">
                <el-button type="text" @click="handleDetails(row)">
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </UDLayout>
      </div>
      <div class="info-warp">
        <Tabs v-model="activeName" class="order-info-tabs">
          <TabPane label="工单信息" name="first">
            <div style="margin: 0 15px">
              <PcParser
                ref="workParser"
                v-if="formDesignData"
                :form-data="formDesignData"
                :displayData="displayData"
                :disabled="true"
              ></PcParser>
            </div>
          </TabPane>
          <TabPane label="动态" name="second">
            <Dynamic :taskTodo="taskTodo" />
          </TabPane>
        </Tabs>
      </div>
    </div>
    <div class="action-row">
      <el-button type="primary" style="padding: 10px 20px" @click="openRecover" icon="el-icon-menu">
        查看任务流转示意图
      </el-button>
    </div>

    <el-dialog
      title="任务引擎 - 任务逻辑流转示意图"
      :visible.sync="taskVisible"
      top="5vh"
      width="80%"
      :custom-class="'common-dialog'"
      append-to-body
    >
      <article class="dialog-main" v-if="taskVisible">
        <TaskRecover
          :taskEngineId="taskEngineId"
          :taskRecoverId="taskRecoverId"
          :workOrderId="workOrderId"
        ></TaskRecover>
      </article>
      <div slot="footer">
        <el-button type="default" @click="closeModal" style="margin-right: 10px;">取消</el-button>
        <el-button type="primary" @click="closeModal">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * @description 共单大项详情
 */
import UDLayout from '../components/UDLayout.vue'
import Dynamic from '@/views/workOrder/components/dynamic/index.vue'
import { Tabs, TabPane } from 'element-ui'
import {dataInterface,transFieldsUUid} from "@/apis/data";
import TaskRecover from "@/views/workOrder/task-flow/TaskRecover";
import eventBus from "@/plugins/eventBus";
export default{
  name: 'OrderInfo',
  components: { UDLayout, Tabs,  TabPane, Dynamic, TaskRecover},
  props:['list','workOrderId','taskEngineId','taskRecoverId','taskTodo'],
  data() {
    return {
      tableData: this.list,
      activeName: 'first',
      formDesignData: null,
      displayData: {},
      contentConfig:{
        objectUUID: 'object62946b8979e52',
        formUUID: 'form629470323f11f',
      },
      taskVisible: false
    }
  },
  computed:{
    getUsers(){
      return function(target){
        const name = Array.from(target,item=>item.name)
        return name.join(',')
      }
    },
  },
  mounted() {
    this.initParser()
  },
  methods: {
    initParser(){
      const reqDara = {
        __method_name__: 'dataInfo',
        object_uuid: 'object62946b8979e52',
        view_uuid: 'view62956d844d681',
        data_id: this.workOrderId,
        transcode: 1
      }
      this.loading = true
      dataInterface(reqDara).then(res => {
        if (res.data.code === 200) {
          this.displayData = res.data.data
          this.initFormDesign(this.contentConfig)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openRecover(){
      this.taskVisible = true
    },
    closeModal(){
      this.taskVisible = false
    },
    /**
     * @desc: 初始化表单
     */
    initFormDesign(contentConfig) {
      if (!contentConfig) return;
      this.loading = true;
      transFieldsUUid(contentConfig.objectUUID, contentConfig.formUUID).then((res) => {
        if (res.data.code == 200) {
          this.formDesignData = res.data.data;
        }
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    handleDetails(row) {
      let id = this.workOrderId
      eventBus.$emit('show-form',{id:id, node: row.nodeId})
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.common-dialog)  {
  .el-dialog__body{
    padding: 0;
  }
}

.dialog-main{
  padding: 0 15px;
  height: calc(100vh - 200px);
  overflow-y: auto;
}
  .order-info-container{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    .main{
      flex-grow: 1;
      height: 10px;
      display: flex;
      .table-warp{
        flex-grow: 1;
        min-width: 10px;
        height: 100%;
        .table-title{
          padding: 13px 24px;
          box-sizing: border-box;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #272829;
        }
        :deep(.order-table-header) {
          background: #F2F5FC !important;
          height: 48px;
          th{
            background-color: transparent;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #272829;
            padding-left: 10px;
          }
        }
        :deep(.order-table-row) {
          td{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #272829;
            padding-left: 10px;
          }
        }
        .status{
          display: inline-block;
          border-radius: 12px;
          padding: 0 12px;
          box-sizing: border-box;
        }
        .status-1{
          background: #E0F4FF;
          color: #0088CC;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
        .status-2{
          background: #E1F5E7;
          color: #21A35D;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }
      .info-warp{
        width: 392px;
        height: 100%;
        border-left: 1px solid #f1f1f1;
        .order-info-tabs{
          height: 100%;
          :deep(.el-tabs__header) {
            padding: 0 10px;
            box-sizing: border-box;
          }
          :deep(.el-tabs__nav-wrap::after) {
            height: 0;
          }
          :deep(.el-tabs__content) {
            height: calc(100% - 60px);
            overflow: auto;
          }
        }
      }
    }
    .action-row{
      width: 100%;
      height: 64px;
      padding: 0 24px;
      border-top: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
    }
  }
</style>
